// src/services/userRoleService.js

import apiClient from "./apiClient";
import { createMissingTables } from "./subscriptionService";
import { getOrganizationId } from "../utils/organizationUtils";

const API_URL = `/wards`; // Use relative path since apiClient has baseURL

const isMissingTableError = (error) => {
  const message = error?.response?.data?.message || error?.message || "";
  return (
    error?.response?.status === 500 &&
    (message.includes("does not exist") ||
      message.includes("from table") ||
      message.includes("Failed to"))
  );
};

export const createWard = async (wardData) => {
  // Remove organizationId from wardData if it exists (apiClient will add it as query param)
  const { organizationId, ...wardDataWithoutOrgId } = wardData;
  
  // apiClient will automatically add organizationId as query parameter via interceptor
  // (not in body, as Ward DTO doesn't accept it in request body)
  try {
    const response = await apiClient.post(`${API_URL}/create`, wardDataWithoutOrgId);
    return response.data;
  } catch (error) {
    // If org-specific tables are missing, create them once and retry.
    if (isMissingTableError(error)) {
      const orgId = getOrganizationId();
      if (orgId) {
        await createMissingTables(orgId);
        const retryResponse = await apiClient.post(`${API_URL}/create`, wardDataWithoutOrgId);
        return retryResponse.data;
      }
    }
    throw error;
  }
};

export const updateWard = async (id, wardData) => {
  // Remove organizationId from wardData if it exists (apiClient will add it as query param)
  const { organizationId, ...wardDataWithoutOrgId } = wardData;
  
  // apiClient will automatically add organizationId as query parameter via interceptor
  // (not in body, as Ward DTO doesn't accept it in request body)
  const response = await apiClient.put(`${API_URL}/${id}`, wardDataWithoutOrgId);
  return response.data;
};

export const deleteWard = async (id) => {
  const response = await apiClient.delete(`${API_URL}/${id}`);
  return response.data;
};

export const getAllWards = async () => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    // If user has no organizationId, backend should use base table
    const response = await apiClient.get(API_URL);
    return response.data;
  } catch (error) {
    // Handle case where organization-specific table doesn't exist yet or backend error
    if (error.response?.status === 500 && 
        (error.response?.data?.message?.includes("Failed to retrieve") ||
         error.response?.data?.message?.includes("from table") ||
         error.response?.data?.message?.includes("does not exist"))) {
      console.warn("Organization-specific table not found, returning empty array:", error.response.data.message);
      return []; // Return empty array if table doesn't exist
    }
    console.error("Error fetching wards:", error);
    throw error;
  }
};

export default {
  createWard,
  getAllWards,
  updateWard,
  deleteWard,
}